

export const Header = {
	template: `
		<div class="calendar-sharing_header">
			<slot/>
		</div>
	`,
};
